module.exports = __webpack_public_path__ + "img/bari.c3e152c.webp";